<template>
  <img
    v-if="hasLogoImage"
    :src="logoImage"
    :alt="name"
    class="w-24 h-auto"
    :class="key"
  >
  <span
    v-else
    class="text-base font-semibold"
  >
    {{ name }}
  </span>
</template>

<script lang="ts" setup>
import { assetUrl, parameterize } from '@/utils'

import Albertsons from '@/assets/images/albertsons.svg'
import CVS from '@/assets/images/cvs.svg'
import Walmart from '@/assets/images/walmart.svg'
import Heb from '@/assets/images/heb.svg'
import MarketStreet from '@/assets/images/market-street.svg'
import Safeway from '@/assets/images/safeway.svg'
import Target from '@/assets/images/target.svg'
import TomThumb from '@/assets/images/tom-thumb.svg'
import Wegmans from '@/assets/images/wegmans.svg'
import WholeFood from '@/assets/images/whole-foods.svg'
import HarrisTeeter from '@/assets/images/harris-teeter.svg'
import Meijer from '@/assets/images/meijer.svg'
import Raleys from '@/assets/images/raleys.svg'
import Costco from '@/assets/images/costco.svg'
import FredMeyer from '@/assets/images/fred-meyer.svg'

export interface Props {
  name: string
}
const props = defineProps<Props>()

const LOGOS = {
  'albertsons': Albertsons,
  'cvs': CVS,
  'costco': Costco,
  'walmart': Walmart,
  'heb': Heb,
  'market-street': MarketStreet,
  'wegmans': Wegmans,
  'safeway': Safeway,
  'target': Target,
  'tom-thumb': TomThumb,
  'whole-foods-market': WholeFood,
  'harris-teeter': HarrisTeeter,
  'meijer': Meijer,
  'raleys-supermarkets': Raleys,
  'fred-meyer': FredMeyer
}
const NAMES = Object.keys(LOGOS)
const key = parameterize(props.name)
const hasLogoImage = NAMES.includes(key)
const logoImage = assetUrl(LOGOS[key])
</script>

<style scoped>
.cvs {
  width: auto;
  height: 14px;
}
.meijer,
.raleys-supermarkets {
  width: 3.5rem;
}
.harris-teeter {
  width: 7.5rem;
}
.costco,
.target {
  width: 5rem;
}
</style>
